var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_467_7)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 16.0011C12.4183 16.0011 16 12.4194 16 8.0011C16 3.58282 12.4183 0.00109863 8 0.00109863C3.58172 0.00109863 -3.8147e-06 3.58282 -3.8147e-06 8.0011C-3.8147e-06 12.4194 3.58172 16.0011 8 16.0011Z",
    fill: "#1977F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.114 10.3142L11.4684 8.00113H9.24989V6.50036C9.24989 5.8681 9.55927 5.25046 10.5538 5.25046H11.5629V3.28168C11.5629 3.28168 10.6472 3.12531 9.7719 3.12531C7.94487 3.12531 6.7501 4.23232 6.7501 6.23823V8.00113H4.71832V10.3142H6.7501V15.9044C7.15736 15.9685 7.57474 16.0011 8 16.0011C8.42526 16.0011 8.84264 15.9674 9.24989 15.9044V10.3142H11.114Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_467_7"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.70fd33e4f2b0b8183017c8f8c2edb486.svg";
export { ForwardRef as ReactComponent };